<div class="select-container" #dropdown [class.disabled]="disabled" [class.open]="isOpen">

    <div class="select-field" role="combobox" 
        [attr.aria-expanded]="isOpen" 
        [attr.aria-disabled]="disabled" 
        (click)="toggleDropdown()"
    >
        <span class="select-text">{{ displayValue }}</span>
        <i class="text-gray-600 fa fa-chevron-down fa-sm"></i>
    </div>

    @if (isOpen) {
        <div class="select-dropdown">
            @for (option of options; track option.value) {
                <div class="select-option" 
                    [class.selected]="selectedOption?.value === option.value" 
                    (click)="selectOption(option, $event)"
                >
                    {{ option.label }}
                </div>
            }
        </div>
    }

</div>